import * as Yup from 'yup'; 
import { onlyChars } from 'components/Form/Helpers/Parsers'
import { isNameValid } from 'components/Form/Validations/NamesValidation'
import { AutocompleteValues, FieldTypes, IFields, InputModes } from 'models/Form/FieldsModels'
import { isPhoneNumberValid } from 'components/Form/Validations/PhoneNumberValidation'
import { isEmailEqualCustomValidation, isEmailValid } from 'components/Form/Validations/EmailValidation'
import { getNamesSuggestions } from 'components/Form/Helpers/SuggestionsHandler'

export enum BasicInfoFieldsNames {
   FirstName = "FirstName",
   Surname = "Surname",
   Email = "Email",
   ConfirmEmail = "ConfirmEmail",
   PhoneNumber = "PhoneNumber",
}

export const basicInfoFields: IFields = {
   [BasicInfoFieldsNames.FirstName]: {
      name: BasicInfoFieldsNames.FirstName,
      type: FieldTypes.stringAutocomplet,
      label: "Imię",
      placeholder: "Podaj imię",
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.FirstName,

      getOptionsFunction: getNamesSuggestions,
      visible: true,
      maxLength: 25,
      parser: onlyChars,
      validation: Yup.string().required("Niepoprawna wartość").test(isNameValid),
   },
   
   [BasicInfoFieldsNames.Surname]: {
      name: BasicInfoFieldsNames.Surname,
      type: FieldTypes.string,
      label: "Nazwisko",
      placeholder: "Podaj nazwisko",
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.Surname,
      
      visible: true,
      maxLength: 40,
      parser: onlyChars,
      validation: Yup.string().required("Nieprawidłowa wartość").min(3, "Nieprawidłowa wartość"),
   },

   [BasicInfoFieldsNames.Email]: {
      name: BasicInfoFieldsNames.Email,
      type: FieldTypes.string,
      label: "Adres e-mail",
      placeholder: "Podaj adres e-mail",
      inputMode: InputModes.email,
      browserAutocomplete: AutocompleteValues.Email,

      visible: true,
      maxLength: 40,
      validation: Yup.string().test(isEmailValid)
   },

   [BasicInfoFieldsNames.ConfirmEmail]: {
      name: BasicInfoFieldsNames.ConfirmEmail,
      type: FieldTypes.string,
      label: "Potwierdź adres e-mail",
      placeholder: "Potwierdź adres e-mail",
      inputMode: InputModes.email,
      browserAutocomplete: AutocompleteValues.Off,
      isPasteDisabled: true,

      visible: true,
      maxLength: 40,
      validation: isEmailEqualCustomValidation
   },

   [BasicInfoFieldsNames.PhoneNumber]: {
      name: BasicInfoFieldsNames.PhoneNumber,
      type: FieldTypes.string,
      label: "Nr tel. komórkowego",
      placeholder: "Podaj nr telefonu",
      inputMode: InputModes.numeric,
      browserAutocomplete: AutocompleteValues.Phone,

      visible: true,
      mask: "+48 999-999-999",
      validation: Yup.string().test(isPhoneNumberValid),
   },
}